/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../nls/StringResources',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function (resources, ReactDOM, React, Toolkit, PropTypes) {
	'use strict';

	const { Dialog } = Toolkit;

	class ConfirmationComponent extends React.Component {

		constructor(props = {}) {
			super(props);
			let className = 'dashboardConfirmationDialog';
			if(props.className) {
				className += ` ${props.className}`;
			}
			this.dialogProps = {
				size: props.size || 'small',
				clickaway: false,
				className: className
			};
			this.primaryButtonText = props.primaryButtonText || resources.get('dlg_ok');
			this.secondaryButtonText = props.secondaryButtonText || resources.get('dlg_cancel');
		}

		render() {
			return(
				<Dialog
					{...this.dialogProps}
					onClose={this._onCancel.bind(this)}
				>
					<Dialog.Header title={this.props.title}>
						{this.props.title}
					</Dialog.Header>
					<Dialog.Body>
						{this.props.message || <div className='dialogBody'/>}
					</Dialog.Body>
					<Dialog.Footer>
						<Dialog.Button
							primary
							id='ok'
							label={this.primaryButtonText}
							title={this.primaryButtonText}
							onClick={this._onOK.bind(this)}
						/>
						<Dialog.Button
							label={this.secondaryButtonText}
							title={this.secondaryButtonText}
							id='cancel'
							onClick={this._onCancel.bind(this)}
						/>
					</Dialog.Footer>
				</Dialog>

			);

		}
		_onOK(evt) {
			if (evt) {
				evt.stopPropagation();
			}

			if (this.props.onOK){
				this.props.onOK();
			}
		}

		_onCancel(evt) {
			if (evt) {
				evt.stopPropagation();
			}

			if (this.props.onCancel){
				this.props.onCancel();
			}
		}
	}

	ConfirmationComponent.propTypes = {
		primaryButtonText: PropTypes.string,
		secondaryButtonText: PropTypes.string,
		className: PropTypes.string,
		size: PropTypes.string,
		title: PropTypes.string,
		message: PropTypes.string,
		onOK: PropTypes.func,
		onCancel: PropTypes.func
	};
	return ConfirmationComponent;
});
